export default {
    book: '{product} boeken',
    age_limit: 'Alleen ouder dan {age}',
    upgrade_product: 'Product upgraden',
    choose_product: '{product} kiezen',
    days: '{count} dag | {count} dagen',
    keyless_benefits: {
        label: 'Straight to car {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Volledige verzekering',
            zero_excess: 'Nul eigen risico',
            phone_as_a_key: 'Telefoon als sleutel',
            straight_to_car: 'Geen wachten',
            no_queues: 'Geen wachtrijen',
            online_id_check: 'Online identiteitscontrole',
            self_checkout: 'Zelf uitchecken',
        },
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/nl/quotes/vehicle_card.js